import { render, staticRenderFns } from "./IndexAreaDeNegocio.vue?vue&type=template&id=7a43dff7"
import script from "./IndexAreaDeNegocio.vue?vue&type=script&lang=js"
export * from "./IndexAreaDeNegocio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports